@if (msfps.getCurrentPreview()) {
  <span>
    @for (item of msfps.getBreadcrumb(); track item; let lastItem = $last) {
      <span
        [ngClass]="{
          'text-primary': !lastItem,
          'fw-bold': lastItem,
        }"
      >
        {{ item }}
      </span>
      @if (!lastItem) {
        <span>&nbsp;&gt;&nbsp;</span>
      }
    }
  </span>
}
